/**
 * Trademark superscript glyph.
 *
 * Uses standard `vertical-align: super` with reduced font-size and zero
 * line-height so the glyph tucks tight to the word without floating high
 * above the cap-line. Applied consistently across header, footer, and all
 * inline references to Adiora™ / Mitraa™.
 */
export default function TM({ className = "" }) {
  return (
    <span
      aria-hidden="true"
      className={`opacity-70 font-normal ${className}`}
      style={{ fontSize: "0.6em", verticalAlign: "super", lineHeight: 0, marginLeft: "0.05em" }}
    >
      ™
    </span>
  );
}
